/* global axios */

import ApiClient from '../ApiClient';

class OlistAPI extends ApiClient {
  constructor() {
    super('integrations/olist', { accountScoped: true });
  }

  show(contactId) {
    return axios.get(this.url, { params: { contact_id: contactId } });
  }

  status() {
    return axios.get(`${this.url}/status`);
  }

  update(payload) {
    return axios.patch(this.url, { olist: payload });
  }

  syncProducts() {
    return axios.post(`${this.url}/sync_products`);
  }

  searchCustomers(contactId, searchParams = {}) {
    return axios.get(`${this.url}/search_customers`, {
      params: { contact_id: contactId, ...searchParams },
    });
  }

  link(contactId, customer) {
    return axios.post(`${this.url}/link`, {
      contact_id: contactId,
      customer,
    });
  }

  refresh(contactId) {
    return axios.post(`${this.url}/refresh`, { contact_id: contactId });
  }

  unlink(contactId) {
    return axios.delete(`${this.url}/unlink`, {
      params: { contact_id: contactId },
    });
  }
}

export default new OlistAPI();
